module.exports = __webpack_public_path__ + "static/img/mouth_pop_correct.e308468.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mouth_pop_correct.png
// module id = SYKB
// module chunks = 0